'use client'

import styled from 'styled-components'

export const VideoDialogWrapper = styled.div`
  position: absolute;
  top: calc(50%);
  left: calc(50%);
  transform: translate(-50%, -50%);
`
